import type { ComponentProps } from 'react';
import React from 'react';
import UserDetailPreview from './UserDetailPreview';
import * as styles from './UserDetailPreviewPopOver.module.scss';
import FloatingCard from '../components/FloatingCard';
import HoverView from '../components/HoverView';

interface UserDetailPreviewPopOverProps
  extends Pick<ComponentProps<typeof HoverView>, 'placement' | 'hoverDelay'> {
  userId: string;
  children: React.ReactNode;
}

const UserDetailPreviewPopOver = ({
  userId,
  children,
  placement,
  hoverDelay,
}: UserDetailPreviewPopOverProps) => (
  <HoverView
    placement={placement}
    hoverDelay={hoverDelay}
    view={
      <FloatingCard className={styles.view}>
        <UserDetailPreview userId={userId} />
      </FloatingCard>
    }
  >
    {children}
  </HoverView>
);

export default UserDetailPreviewPopOver;
